/**
 * 创建分享出去的页面，将相同代码封装到这里，需要从链接上获取参数，链接参数说明
 * type=1&activityId=453&ticket=4E3BFCF86122C90017B991C4A2482081&emplid=SZK190012&way=1&code=xxxx
 * type：标识活动类型 0=普通上架活动 1=企业微信H5上架活动
 * activityId：活动id
 * ticket：验签，避免直接使用id查询，防止撞库
 * emplid：TMR id，只有从企业微信右侧栏转发时才会有
 * way：标识来源 1=正常访问，加访问次数；2=TMR企业微信右侧栏访问详情页面，不加访问次数
 * code：微信授权码，只有经过微信授权才有
 * x: 1 = 小程序跳转过来 2 = 非小程序微信页面
 */
import Vue from "vue";
// import Vuex from "vuex";
import qs from "qs";
import share from "cignacmb-share/src/index.js";
import { setUUID } from "./sharePageMethod.js";
import {
  getActivityShareInfo,
  addRetransmissionTimes,
  getActivityH5ShareInfo,
  getEmployeeInfo,
  saveConsumerTransmitRecord,
  longToShort
} from "../services/share-pages.js";
import SharePage from "../components/SharePage.vue";
// import { mapMutations} from "vuex";
// import {setFormDate} from "../pages/index/store/mutation-types.js"
// Vue.use(Vuex);
// const store=new Vuex.store({});
// new Vue({
//   store
// })

if (process.env.VUE_APP_ENV_TYPE != 'production') {
  var VConsole = require('vconsole');
  new VConsole();
}

Vue.mixin({
  methods: {
    sensorsAdd(objData) {
      try {
        for (let EventName in objData) {
          let sensorsData = objData[EventName];
          console.log(
            EventName, "-----EventName2------",
            sensorsData, "---====--==-sensorsData"
          );
          window.sensors.track(EventName, sensorsData);
        }
      } catch (e) {
        console.log(e)
      }
    }
   
  }
});

const getShareUrl = function (extraQuery) {
  const query = qs.parse(window.location.search.slice(1));
  const params = [];
  let redirect = "/share-redirect.html";
  let url = location.origin + location.pathname.replace(/\/[^/]+.html?/, redirect);

  for (let key in extraQuery) {
    query[key] = extraQuery[key];
  }
  for (let key in query) {
    if (key != "code") {
      params.push(
        `${key}=${encodeURIComponent(encodeURIComponent(query[key]))}`
      );
    }
  }

  return `${url}?${params.join("&")}`;
};

export default function (App, pageName) {
  var ua = navigator.userAgent
  console.log(ua.match(/wxwork/i) == 'wxwork',ua,'332')
  const query = qs.parse(window.location.search.slice(1));
  console.log("query-!!!!",query)
  if(!(ua.match(/wxwork/i) == 'wxwork')) { // 微信端打开判断
    if(!query.code) {
      //不是甜心同屏和小程序才进去微信静默授权
      const targetUrl = window.location.href
      if(targetUrl.indexOf("source=evntp")  == -1  && targetUrl.indexOf("channelCode=weix") == -1){
        let params ={}
        params.link = targetUrl
        longToShort(params).then(data => {
        let  targetUrls = data
           const array = [
             // "appid=wx9de7849179fa4533",
             // "redirect_uri=https://weixin.test-cignacmb.com/wxweb/oauth2fetchcode.xhtml",
             "appid=" + process.env.VUE_APP_APPID,
             "redirect_uri=" + process.env.VUE_APP_REDIRECT_URI,
             "response_type=code",
             "scope=snsapi_userinfo",
             "state=" + encodeURIComponent(targetUrls),
           ];
          location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?${array.join(
            "&"
          )}#wechat_redirect`;
        }) 
      }
    }
  }

  let uuidData = setUUID();
  if (!uuidData.isMyActivity) {
    //如果不是本人的活动则调转发接口
    addRetransmissionTimes({ activityId: query.activityId, times: 1 });
  }
 
  // 区分是素材库活动还是企业微信H5上架活动 type=0 是素材库普通上架活动
  if (!query.type) {
    query.type = "0";
  }
  // 简单的state对象
  const state = new Vue({
    data() {
      return {
        shareInfo: {},
        errMsg: null,
        empInfo: {}, //员工信息
        formData:{}
      }
    }
  });
  if(!query.x) {
    query.source = 2
  } else {
    query.source = 1
    delete query.x
  }
  // var reg = RegExp(/wxwork_userid/)
  // for(let i in query) {
  //   if(reg.exec(i)) {
  //     console.log(i,'kk')
  //     delete query.i
  //   }
  // }
  delete query.wxwork_userid
  // 是否有员工号
  if (query.emplid) {
    getEmployeeInfo({
      emplid: query.emplid,
    }).then((res) => {
      state.empInfo = res;
      // console.log(res, "------getEmployeeInfo");
    });
  } else {
    query.emplid = ''
  }
  
  // 根据type判断调用不同的接口获取活动信息
  let promise = null;
  // if(query.code) {
    if (query.type == "1") {
      // type=1 是企业微信H5上架活动
      
      promise = getActivityH5ShareInfo(query);
    } else {
      // type=0 是普通上架活动
      promise = getActivityShareInfo(query);
    }
  // }
  
  // if (query.transmitUnionid) {
  //   saveConsumerTransmitRecord({transmitEmplid: query.emplid, activityId:query.emplid,transmitUnionid:query.transmitUnionid})
  // }
  // ...mapMutations(["setFormDate"]),
  promise.then(
    function resolve (data) {
      console.log("data",data)
      state.formData = Object.assign(data,{'browseTimes':data.browseTimes});
      state.formData = Object.assign(data,{'unionId':data.unionId});
      //  Vue.set(state.formData,"browseTimes",data.browseTimes);
      //  Vue.set(state.formData,"unionId",data.unionId);
      console.log("state.formData",state.formData)
      localStorage.setItem('formData', JSON.stringify(state.formData))
      // this.$store.commit('setFormDate',state.formDate)
      // this.setFormDate(state.formDate);
      state.shareInfo = data;
      console.log("state.shareInfo",state.shareInfo)
      if((location.href.match(/share-links-pages/i) == 'share-links-pages')) {
        const eva = state.shareInfo.activityTemplet.indexOf("?") == -1 ? "?eva=" : "&eva="
        state.shareInfo.activityTemplet = state.shareInfo.activityTemplet.replace(/\s+/g, "") + eva + query.emplid + "&userId=" + query.userId;
      }
      console.log("state.shareInfo222",state.shareInfo)
      document.title = data.shareTitle;
      if(query.transmitUnionid) {
        saveConsumerTransmitRecord({transmitEmplid: query.emplid, activityId:query.activityId,transmitUnionid:query.transmitUnionid, unionId:data.unionId})
        
      }
      
      let transmitParams = {}
      if(!query.transmitUnionid) {
        query.transmitUnionid = data.unionId
        transmitParams = {
          pages: pageName,
          uuid: uuidData.UUID_MINE,
          type: query.type,
          transmitUnionid: query.transmitUnionid
        }
        
      } else if(query.transmitUnionid && !query.unionid) {
         
        transmitParams = {
          pages: pageName,
          uuid: uuidData.UUID_MINE,
          type: query.type,
          transmitUnionid: query.transmitUnionid,
          unionid: data.unionId
        }
      } else {
        transmitParams = {
          pages: pageName,
          uuid: uuidData.UUID_MINE,
          type: query.type,
          transmitUnionid: query.unionid,
          unionid: data.unionId
        }
        
      }
      // console.log(getShareUrl(transmitParams),'sssssssss')
      share(
        {
          url: getShareUrl(transmitParams),
          title: data.shareTitle,
          content: data.shareContent,
          image: data.shareIcon,
        },
        { withGuide: false }
      );
      // console.log('share已调用')
    },
    function reject(err) {
      // 显示活动已下架等
      if ("statusCode" in err && err.statusCode == "204") {
        state.errMsg = err.msg;
      }
    }
  );

  // 生成主页面
  new Vue({
    render() {
      return (
        <SharePage empInfo={state.empInfo} errMsg={state.errMsg}>
          <App shareInfo={state.shareInfo}/>
        </SharePage>
      );
    }
  }).$mount("#app");
}